import React from "react";
import styled from "styled-components";
import { reduxForm, Form } from "redux-form";
import { Field } from "redux-form";

import { FormInput } from "../../../common/components";
import strings from "../../../../res/strings";

const ResetPasswordFormContainer = styled(Form)`
  padding: 15%;
  padding-top: 25vh;
`;
const ResetPasswordFormContent = styled.div`
  margin: 16px;
`;
const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 8px;
`;
const SendResetPasswordSubmitButton = styled.button`
  width: 100%;
  background: #039095;
  border-radius: 250.251px;
  font-size: 1.5em;
  font-family: Secular One;
  color: #ffffff;
  align-items: center;
  text-align: center;
  letter-spacing: 0.05em;
  padding: 16px;
`;
const ResetPasswordTitle = styled.div`
  font-family: Secular One;
  font-style: normal;
  font-weight: normal;
  font-size: 2em;
  line-height: 73px;
  letter-spacing: 0.1em;

  color: #929292;
  text-align: center;
`;
const RouterLink = styled.a`
  color: #929292;
  font-family: Secular One;
  cursor: pointer;

  :hover {
    color: #7a7a7a;
  }
`;
const BackToLoginContent = styled.div`
  margin-top: 16px;
  width: 100%;
  text-align: center;
`;

let ResetPasswordForm = (props) => {
  return (
    <ResetPasswordFormContainer onSubmit={props.handleSubmit}>
      <ResetPasswordFormContent>
        <ResetPasswordTitle>RESET PASSWORD</ResetPasswordTitle>
        <Field
          name="email"
          component={FormInput}
          label={strings.lib_authentication_label_email}
          type="email"
          required
          maxlength={255}
          placeholder={"EMAIL"}
        />

        <ButtonContainer>
          <SendResetPasswordSubmitButton type="submit" color="primary">
            SEND RESET PASSWORD EMAIL
          </SendResetPasswordSubmitButton>
        </ButtonContainer>
      </ResetPasswordFormContent>
      <BackToLoginContent>
        <RouterLink
          onClick={() => {
            props.setRightPanel("LOGIN");
          }}
        >
          Go back to Login
        </RouterLink>
      </BackToLoginContent>
    </ResetPasswordFormContainer>
  );
};

const ReduxResetPasswordForm = reduxForm({
  form: "lib_authentication_reset_password",
})(ResetPasswordForm);

export default ReduxResetPasswordForm;
